module.exports = class ABQLManager {};
